<template>
  <sea-page-content toolbar hideRapidSearch in-tab>
    <template v-slot:toolbar>
      <table-toolbar-button
        icon="mdi-printer-outline"
        label="Stampa il documento"
        @click="download(data)"
        :disabled="!preview"
      ></table-toolbar-button>
      <table-toolbar-button
        icon="mdi-arrow-up-circle-outline"
        label="Pagina precedente"
        @click="pageDown"
        :disabled="!preview || currentPage === 1"
      ></table-toolbar-button>
      <table-toolbar-button
        icon="mdi-arrow-down-circle-outline"
        label="Pagina successiva"
        @click="pageUp"
        :disabled="!preview || currentPage === pageCount"
      ></table-toolbar-button>
      <input
        type="text"
        class="inp"
        v-model="curr"
        @input="changePage"
        maxlength="2"
        :disabled="!preview"
      /><span style="font-size: 1em" class="mr-1">/ {{ pageCount }}</span>
    </template>
    <v-card elevation="2">
      <v-card-text>
        <v-row>
          <v-col cols="7">
            <div v-if="docLoading" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <div v-else>
              <div v-if="preview">
                <div style="width: 75%" class="mx-auto hidden-md-and-down">
                  <v-slider
                    class="ml-2"
                    v-model="zoomLevel"
                    append-icon="mdi-magnify-plus-outline"
                    prepend-icon="mdi-magnify-minus-outline"
                    :max="zoomMax"
                    :min="zoomMin"
                    :step="zoomStep"
                    @click:append="zoomIn"
                    @click:prepend="zoomOut"
                    thumb-label
                  >
                    <template v-slot:thumb-label="{ value }">
                      {{ value - 50 }}%
                    </template>
                  </v-slider>
                </div>
                <div
                  id="pdfContainer"
                  :style="{ maxWidth: pdfContainerWidth, height: pdfHeight }"
                  class="overflow-y-auto overflow-x-auto mx-auto"
                >
                  <div :style="{ width: pdfWidth }" class="mx-auto">
                    <pdf
                      class="bordered"
                      ref="pdfviewer"
                      :src="preview"
                      @num-pages="pageCount = $event"
                      @page-loaded="currentPage = $event"
                      :page="page"
                    ></pdf>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="5">
            <div v-if="data">
              <v-card elevation="2" class="pa-2">
                <div class="d-flex flex-row align-center">
                  <span class="font-weight-bold text-caption text-lg-body-1"
                    >Titolo:
                  </span>
                  <span class="ml-1 text-caption text-lg-body-1">
                    {{ data.descrizione }}</span
                  >
                </div>
                <div class="d-flex flex-row align-center">
                  <span class="font-weight-bold text-caption text-lg-body-1"
                    >Data elaborazione:
                  </span>
                  <span class="ml-1 text-caption text-lg-body-1">
                    {{ data.dataElaborazione | dateFormat }}</span
                  >
                </div>
                <div class="d-flex flex-row align-center">
                  <span class="font-weight-bold text-caption text-lg-body-1"
                    >Data scadenza:
                  </span>
                  <span class="ml-1 text-caption text-lg-body-1">
                    {{ data.dataScadenza | dateFormat }}</span
                  >
                </div>
                <div class="d-flex flex-row align-center">
                  <span class="font-weight-bold text-caption text-lg-body-1"
                    >Professionista:
                  </span>
                  <span class="ml-1 text-caption text-lg-body-1">
                    {{ data.createdByCognome }}
                    {{ data.createdByNome }}</span
                  >
                </div>
              </v-card>
            </div>
            <div v-else class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <div v-if="items">
              <v-card
                color="#EFF7FF"
                elevation="2"
                class="pa-2 mt-2 scroll-bottom"
              >
                <v-btn
                  fab
                  x-small
                  class="ma-2"
                  color="primary"
                  @click="updateChatList()"
                  ><v-icon>mdi-reload</v-icon></v-btn
                >
                <div
                  class="overflow-y-auto overflow-x-hidden d-flex flex-column"
                  :style="{ height: chatHeight }"
                  ref="chatContainer"
                >
                  <div v-for="item in items" :key="item.id">
                    <v-card
                      max-width="45%"
                      class="mx-5 ma-2 pa-1"
                      :class="
                        item.createdBy === account.login
                          ? 'round-to float-right'
                          : 'round-from float-left'
                      "
                      :color="
                        item.createdBy === account.login ? '#0091FF' : '#E7E6EB'
                      "
                      :dark="item.createdBy === account.login ? true : false"
                      ><div
                        class="text-right"
                        v-if="item.createdBy === account.login"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              x-small
                              v-bind="attrs"
                              v-on="on"
                              style="cursor: pointer"
                              @click="deleteMessage(item.id)"
                              >mdi-close-circle</v-icon
                            >
                          </template>
                          <span>Elimina messaggio</span>
                        </v-tooltip>
                      </div>
                      <div
                        class="py-1 px-3 text-caption text-lg-body-1"
                        style="word-break: keep-all; width: 100%"
                      >
                        {{ item.testo }}
                      </div>
                      <div
                        class="mx-3 float-right"
                        :class="
                          item.createdBy === account.login
                            ? 'format-date-light'
                            : 'format-date'
                        "
                      >
                        <template v-if="item.createdBy !== account.login">
                          {{ item.createdBy }} -
                        </template>
                        {{ item.createdDate | dateFormat }} -
                        {{ item.createdDate | hourFormat }}
                      </div>
                    </v-card>
                  </div>
                </div>
                <div>
                  <v-text-field
                    class="mt-2"
                    @keyup.enter="sendChat"
                    rounded
                    append-outer-icon="mdi-send"
                    @click:append-outer="sendChat"
                    background-color="#FFFF"
                    :color="message ? 'primary' : '#6E7175'"
                    clear-icon="mdi-close-circle"
                    v-model="message"
                    placeholder="Inserisci il tuo messaggio"
                    solo
                    clearable
                    hide-details
                  ></v-text-field>
                </div>
              </v-card>
            </div>
            <div v-else class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </sea-page-content>
</template>

<script>
import pdf from "vue-pdf";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "doc-preview",
  props: {
    data: { type: Object },
  },
  components: { pdf },
  data() {
    return {
      docLoading: true,
      message: "",
      chat: null,
      preview: null,
      currentPage: 0,
      pageCount: 0,
      page: 1,
      curr: 1,
      zoomLevel: 50,
      zoomMax: 550,
      zoomMin: 100,
      zoomStep: 10,
    };
  },
  methods: {
    ...mapActions({
      downloadDoc: "docsLav/downloadDocForPreview",
      fetchList: "docsLav/fetchAnnotations",
      send: "docsLav/sendMessage",
      _deleteMessage: "docsLav/deleteMessage",
      download: "docsLav/downloadDocument",
    }),
    updateChatList() {
      this.fetchList(this.data.id).then(() => {
        const el = this.$refs.chatContainer;

        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },
    async sendChat() {
      if (this.message) {
        const payload = { id: this.data.id, message: this.message };
        await this.send(payload);
        await this.updateChatList();
        this.message = "";
      }
    },
    deleteMessage(id) {
      this._deleteMessage(id).then(() => this.updateChatList());
    },
    pageUp() {
      this.page += 1;
      this.curr = this.page;
    },
    pageDown() {
      this.page -= 1;
      this.curr = this.page;
    },
    changePage() {
      const p = Number(this.curr);
      if (!isNaN(p) && p !== 0 && p <= this.pageCount) {
        this.page = p;
      }
    },
    print() {
      this.$refs.pdfviewer.print();
    },
    zoomIn() {
      if (this.zoomLevel < this.zoomMax) this.zoomLevel += this.zoomStep;
    },
    zoomOut() {
      if (this.zoomLevel > this.zoomMin) this.zoomLevel -= this.zoomStep;
    },
  },
  computed: {
    ...mapGetters({
      items: "docsLav/annotations",
      account: "account/account",
    }),
    pdfContainerWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "lg":
          return "550px";
        case "xl":
          return "800px";
        default:
          return null;
      }
    },
    pdfWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "lg":
          return `${Math.floor(315 * (this.zoomLevel / 100))}px`;
        case "xl":
          return `${Math.floor(420 * (this.zoomLevel / 100))}px`;
        default:
          return null;
      }
    },
    pdfHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "md":
          return "calc(100vh - 225px)";
        default:
          return "calc(100vh - 270px)";
      }
    },
    chatHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "md":
          return "calc(100vh - 500px)";
        default:
          return "calc(100vh - 515px)";
      }
    },
  },
  watch: {
    async data() {
      const ext = this.data.nomeFile.split(".").pop();
      if (ext && ext.toLowerCase() === "pdf") {
        this.downloadDoc(this.data.id).then((res) => {
          this.preview = new Uint8Array(res);
          this.docLoading = false;
        });
      } else {
        this.docLoading = false;
      }
      this.updateChatList();
    },
  },
};
</script>

<style>
.inp {
  width: 35px;
  border-style: solid;
  height: 25px;
  margin: 6px;
  font-size: 1em;
}

.scroll-bottom {
  position: relative;
  bottom: 0;
}
.format-date {
  color: #455a64;
  font-size: 0.5vw;
}
.format-date-light {
  color: #eceff1;
  font-size: 0.5vw;
}
.v-card__text {
  padding: 2px;
}
.round {
  border-radius: 20px;
}

.round-to {
  border-radius: 20px 0px 20px 20px !important ;
}
.round-from {
  border-radius: 0px 20px 20px 20px !important ;
}
</style>